import React, { useState, useContext } from 'react';
import { AuthContext } from '../App';
import api from '../utils/api';
export default function LoginPage() {
  const { setUser } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { username, password });
      setUser(data);
    } catch (err) { setError(err.response?.data?.error || 'Ошибка подключения'); }
    finally { setLoading(false); }
  };
  return (
    <div className="login-page">
      <div className="login-box">
        <h1>БанкротCRM</h1>
        <p>Внесудебное банкротство физических лиц</p>
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input className="form-input" placeholder="Логин" value={username} onChange={e => setUsername(e.target.value)} autoFocus />
          <input className="form-input" type="password" placeholder="Пароль" value={password} onChange={e => setPassword(e.target.value)} />
          <button className="btn btn-primary" type="submit" disabled={loading}>{loading ? 'Вход...' : 'Войти'}</button>
        </form>
      </div>
    </div>
  );
}
